import React from 'react';
import './Skeleton.css';

/**
 * Skeleton — shimmer loader primitive.
 *
 * Props:
 *   variant: 'text' | 'title' | 'circle' | 'rect' | 'card'  (default 'text')
 *   width / height: CSS size override
 *   lines: number — for variant='text', renders multiple staggered rows
 *   className
 */
export function Skeleton({
  variant = 'text',
  width,
  height,
  lines = 1,
  className = '',
  style,
  ...rest
}) {
  const baseClass = `ui-skeleton ui-skeleton--${variant}`;

  if (variant === 'text' && lines > 1) {
    return (
      <div className={`ui-skeleton-stack ${className}`} {...rest}>
        {Array.from({ length: lines }).map((_, i) => (
          <span
            key={i}
            className={baseClass}
            style={{
              width:
                i === lines - 1 ? '62%' : i === 0 ? '88%' : '100%',
              ...style,
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <span
      className={`${baseClass} ${className}`}
      style={{ width, height, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
}

export default Skeleton;
